import { render, staticRenderFns } from "./SubscriptionsScreen.vue?vue&type=template&id=391e9e96&scoped=true&"
import script from "./SubscriptionsScreen.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsScreen.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsScreen.vue?vue&type=style&index=0&id=391e9e96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e9e96",
  null
  
)

export default component.exports